module.exports = __webpack_public_path__ + "static/media/psPerks3.71a974a5.jpeg";